export const logsUrl = '/logging/log'
